import { render, staticRenderFns } from "./data-table-create-calculation-tabs.vue?vue&type=template&id=1219654a&scoped=true&"
import script from "./data-table-create-calculation-tabs.vue?vue&type=script&lang=js&"
export * from "./data-table-create-calculation-tabs.vue?vue&type=script&lang=js&"
import style0 from "./data-table-create-calculation-tabs.vue?vue&type=style&index=0&id=1219654a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1219654a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1219654a')) {
      api.createRecord('1219654a', component.options)
    } else {
      api.reload('1219654a', component.options)
    }
    module.hot.accept("./data-table-create-calculation-tabs.vue?vue&type=template&id=1219654a&scoped=true&", function () {
      api.rerender('1219654a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/data-table-create-calculation-tabs.vue"
export default component.exports